module.exports = "<p text-center>\n  Temps : {{texte}}\n</p>\n"